import React from "react";
import { Link } from "react-router-dom";
import NewsletterSignup from "./NewsletterSignup";

export default function Footer() {
  return (
    <footer className="bg-[#0A0E0B] border-t-2 border-[#2C332A] mt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="font-anton text-3xl uppercase text-[#E5E5E5]">Everythang</div>
          <div className="font-anton text-sm uppercase tracking-[0.3em] text-[#DD5422]">Redneck</div>
          <p className="text-sm text-[#8D9688] mt-4">Cold beer, big trucks, hot summers. Born in the back roads.</p>
        </div>
        <div>
          <div className="font-anton uppercase text-sm tracking-widest text-[#DD5422] mb-3">Shop</div>
          <ul className="space-y-2 text-sm text-[#8D9688]">
            <li><Link to="/shop" className="hover:text-[#E5E5E5]">All Merch</Link></li>
            <li><Link to="/shop" className="hover:text-[#E5E5E5]">T-Shirts</Link></li>
            <li><Link to="/shop" className="hover:text-[#E5E5E5]">Hoodies</Link></li>
            <li><Link to="/shop" className="hover:text-[#E5E5E5]">Drinkware</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-anton uppercase text-sm tracking-widest text-[#DD5422] mb-3">Hang Out</div>
          <ul className="space-y-2 text-sm text-[#8D9688]">
            <li><Link to="/about" className="hover:text-[#E5E5E5]">About Us</Link></li>
            <li><Link to="/subscribe" className="hover:text-[#E5E5E5]">VIP Subscription</Link></li>
            <li><Link to="/ask" className="hover:text-[#E5E5E5]">Ask a Redneck</Link></li>
            <li><Link to="/videos" className="hover:text-[#E5E5E5]">Funny Videos</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-anton uppercase text-sm tracking-widest text-[#DD5422] mb-3">Drop Alerts</div>
          <p className="text-xs text-[#8D9688] uppercase tracking-widest mb-3">Be first to know when new merch hits.</p>
          <NewsletterSignup />
        </div>
      </div>
      <div className="border-t-2 border-[#2C332A] py-4 text-center text-xs uppercase tracking-[0.3em] text-[#8D9688]">
        © {new Date().getFullYear()} Everythang Redneck. Y'all stay muddy.
      </div>
    </footer>
  );
}
